/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgResetPassword = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 12c0-5.523-4.477-10-10-10a9.985 9.985 0 0 0-8 3.999V3H2v6h6V7H5.754a8 8 0 0 1 14.178 6.047l1.983.26c.056-.428.085-.864.085-1.307zM2 19v-4h2v2h2v-2h2v2h1.126A4.002 4.002 0 0 1 17 18a4 4 0 0 1-7.874 1zm13-1a2 2 0 1 0-4 0 2 2 0 0 0 4 0zm4.934.088-1.586-1.219a7.984 7.984 0 0 0 1.046-1.807l1.847.766a9.987 9.987 0 0 1-1.307 2.26z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgResetPassword as ResetPassword };
